import React, { useState } from 'react';
import {
  Box,
  BreadcrumbItem,
  Breadcrumbs,
  Container,
  Image,
} from '@drivekyte/web-components';
import { useMedia } from '@drivekyte/ui';
import useBreadcrumbsRedirect from '@/hooks/use-breadcrumbs-redirect';
import useScroll from '@/hooks/use-scroll';
import Logo from '../../../logo';

type NavigationCollapsedProps = {
  onPress: () => void;
  subscriptionBreadcrumbs?: BreadcrumbItem[];
};

const LOGO_HEIGHT = 24;
const LOGO_WIDTH = 24;
const MOBILE_HEADER_HEIGHT = 71;

const NavigationCollapsed = ({
  onPress,
  subscriptionBreadcrumbs,
}: NavigationCollapsedProps) => {
  const updateHeaderBorderStatus = (currentScrollPosition: number) => {
    setHeaderBorder(currentScrollPosition > MOBILE_HEADER_HEIGHT / 2);
  };
  const media = useMedia();
  const [headerBorder, setHeaderBorder] = useState(false);
  const handleRedirect = useBreadcrumbsRedirect();

  useScroll(updateHeaderBorderStatus, true);

  const showBorder = !media.xs || headerBorder;

  return (
    <Box
      backgroundColor="primary"
      borderBottomColor={showBorder ? 'primary' : 'none'}
      borderBottomStyle={showBorder ? 'solid' : 'none'}
      borderBottomWidth={showBorder ? 'base' : 'none'}
      position="fixed"
      width="100%"
      zIndex={5}
    >
      <Container>
        <Box
          alignItems="center"
          display="flex"
          justifyContent="space-between"
          paddingVertical="xSmall"
        >
          <Logo />
          <Box
            boxSizing="border-box"
            cursor="pointer"
            onPress={onPress}
            padding="xTiny"
            testID="navigation-collapsed-open"
          >
            <Image
              width={`${LOGO_WIDTH}px`}
              height={`${LOGO_HEIGHT}px`}
              src="/images/icons/menu.svg"
              alt="menu icon"
            />
          </Box>
        </Box>
        {subscriptionBreadcrumbs && (
          <Box marginBottom="small">
            <Breadcrumbs
              items={subscriptionBreadcrumbs}
              onPress={handleRedirect}
            />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default NavigationCollapsed;
